function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { Text } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { MoreHoriz, PaletteOutlined } from "sprout-ui-icons";
import { Menu, MenuTitle, MenuTrigger, MenuItem, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { LabelEditColorDialog } from "@sprout/client-components/dist/Dialog_next";
import useToggle from "@sprout/hooks/dist/useToggle";
import { useTopicPage } from "../TopicPageContext";
const StyledButton = styled(Button)`
  ${({ $variant  })=>$variant === "mobile" && `margin-right: -12px`}
`;
const TopicPageViewsLabelMenu = (props)=>{
    const { variant , label  } = props;
    const isMobile = variant === "mobile";
    const [open, setOpen, setClose] = useToggle();
    const { isOwnerOrAdmin , disabled  } = useTopicPage();
    const isLabelEnabled = isOwnerOrAdmin && !disabled;
    const menuState = useMenuState();
    if (!isLabelEnabled) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsxs(StyledButton, {
                    variant: isMobile ? "circle" : "outline",
                    $variant: variant,
                    children: [
                        /*#__PURE__*/ _jsx(MoreHoriz, {}),
                        !isMobile && /*#__PURE__*/ _jsx(Text, {
                            as: "span",
                            ml: 0,
                            children: "Options"
                        })
                    ]
                })
            })),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                $size: isMobile ? undefined : "264px",
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: "Label Options"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "PAGE_EDIT_LABEL"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Change color",
                        icon: PaletteOutlined,
                        onClick: setOpen
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "PAGE_DELETE"
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(LabelEditColorDialog, {
                open: open,
                onRequestClose: setClose,
                label: label
            })
        ]
    });
};
export default TopicPageViewsLabelMenu;
